import { Injectable } from '@angular/core';
import { AbstractControlOptions } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PatrimonyOriginRepartition,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PatrimonyOriginRepartition> = {
      personally: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.patrimonyOriginRepartition?.personally?.percent * 100,
          ) || 0,
        ],
      }),
      family: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.patrimonyOriginRepartition?.family?.percent * 100,
          ) || 0,
        ],
      }),
      companyOrGroupOrAssociation: this.formBuilder.group({
        percent: [
          this.floored(
            parameters?.patrimonyOriginRepartition?.companyOrGroupOrAssociation
              ?.percent * 100,
          ) || 0,
        ],
      }),
    };
    return this.formBuilder.group(formConfig, options);
  }
  extract() {
    const formValue = _.cloneDeep({ ...this.form.value });
    for (const key in formValue) {
      if (Object.prototype.hasOwnProperty.call(formValue, key)) {
        const element = formValue[key] as any;
        if (typeof element === 'object' && element !== null) {
          element.percent = element.percent / 100;
        }
      }
    }
    return {
      patrimonyOriginRepartition: { ...formValue },
    };
  }
  floored(value) {
    if (value) return Math.round(value * 100) / 100;
  }
}
